import { render, staticRenderFns } from "./CharteredPage.vue?vue&type=template&id=3c6a2054&"
import script from "./CharteredPage.vue?vue&type=script&lang=js&"
export * from "./CharteredPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports